import React, { FC, useContext, useState } from 'react';

import { Button } from '@eika/button';
import { Modal } from '@eika/modal';

import { AppContext } from '../../containers/appContextContainer';
import { useTranslation } from '../../translations';

const UserMessageGeoOmraade: FC = () => {
    const { button, userMessage } = useTranslation();
    const { appNameSpace } = useContext(AppContext);
    const [showModal, setShowModal] = useState<boolean>(true);

    const onClickLukk = () => {
        const redirectUrl = window.location.origin;
        window.location.replace(redirectUrl);
    };

    return (
        <Modal
            id="userMessageGeoOmraade"
            title={userMessage.tittleGeoOmmrade}
            description={userMessage.descriptionGeoOmmrade}
            appNamespace={appNameSpace}
            size="medium"
            setOpen={setShowModal}
            open={showModal}
            hideCloseButton
            onClose={() => setShowModal(false)}
        >
            <div className="column justify-content-center margin-top-extra-large">
                <Button onClick={onClickLukk}>{button.lukk}</Button>
            </div>
        </Modal>
    );
};

export default UserMessageGeoOmraade;
